<div class="text-styling-panel">
  <div class="text-styling-panel__header">
    <h3 class="text-styling-panel__title">Text Style</h3>
    <button
      type="button"
      class="text-styling-panel__close"
      (click)="onClose()"
      aria-label="Close"
    >
      &times;
    </button>
  </div>

  <div class="text-styling-panel__body">
    <!-- Text content -->
    <div class="text-styling-panel__section">
      <label class="text-styling-panel__label">Text</label>
      <textarea
        #contentInput
        class="text-styling-panel__content-input"
        [ngModel]="draftText"
        (ngModelChange)="onTextChange($event)"
        rows="2"
        placeholder="Enter text..."
      ></textarea>
    </div>

    <!-- Font family -->
    <div class="text-styling-panel__section">
      <label class="text-styling-panel__label text-styling-panel__label--with-icon">
        Font
        @if (fontLoadFailed) {
          <img
            class="text-styling-panel__font-error"
            [src]="fontErrorIcon"
            [title]="fontLoadErrorTitle"
            [attr.aria-label]="fontLoadErrorTitle"
            alt=""
          />
        }
      </label>
      <icn-dropdown
        class="text-styling-panel__dropdown"
        [selectedValue]="activeFont"
        (selectedValueChange)="onFontChange($event)"
        [position]="'bottom'"
        [medium]="true"
        [allowMultiple]="false"
        [textAlign]="'left'"
      >
        @for (f of fonts; track f) {
          <icn-dropdown-item [title]="f" [value]="f"></icn-dropdown-item>
        }
      </icn-dropdown>
    </div>

    <!-- Font size + Bold / Italic -->
    <div class="text-styling-panel__section">
      <label class="text-styling-panel__label">Size &amp; Style</label>
      <div class="text-styling-panel__size-row">
        <icn-dropdown
          class="text-styling-panel__dropdown text-styling-panel__dropdown--size"
          [selectedValue]="activeFontSize"
          (selectedValueChange)="onFontSizeChange($event)"
          [position]="'bottom'"
          [medium]="true"
          [allowMultiple]="false"
          [textAlign]="'left'"
        >
          @for (s of fontSizeOptions; track s) {
            <icn-dropdown-item
              [title]="s + ' px'"
              [value]="s"
            ></icn-dropdown-item>
          }
        </icn-dropdown>
        <button
          type="button"
          class="text-styling-panel__format-btn"
          [class.text-styling-panel__format-btn--active]="isBold"
          (click)="toggleBold()"
          title="Bold"
        >
          <strong>B</strong>
        </button>
        <button
          type="button"
          class="text-styling-panel__format-btn"
          [class.text-styling-panel__format-btn--active]="isItalic"
          (click)="toggleItalic()"
          title="Italic"
        >
          <em>I</em>
        </button>
      </div>
    </div>

    <!-- Alignment -->
    <div class="text-styling-panel__section">
      <label class="text-styling-panel__label">Alignment</label>
      <div class="text-styling-panel__alignment">
        <button
          type="button"
          class="text-styling-panel__align-btn"
          [class.text-styling-panel__align-btn--active]="
            activeAlignment === 'left'
          "
          (click)="setAlignment('left')"
        >
          Left
        </button>
        <button
          type="button"
          class="text-styling-panel__align-btn"
          [class.text-styling-panel__align-btn--active]="
            activeAlignment === 'center'
          "
          (click)="setAlignment('center')"
        >
          Center
        </button>
        <button
          type="button"
          class="text-styling-panel__align-btn"
          [class.text-styling-panel__align-btn--active]="
            activeAlignment === 'right'
          "
          (click)="setAlignment('right')"
        >
          Right
        </button>
      </div>
    </div>

    <!-- In / Out time (edit mode only) -->
    <div class="text-styling-panel__section" *ngIf="isEditMode">
      <label class="text-styling-panel__label">In</label>
      <div class="text-styling-panel__time-row">
        <div class="text-styling-panel__time-input-wrap">
          <input
            type="text"
            class="text-styling-panel__time-input"
            [value]="inTimecode"
            (blur)="onInTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="text-styling-panel__time-now-btn"
            title="Set to current playhead time"
            (click)="setInToPlayhead()"
            aria-label="Set In to playhead"
          >
            Now
          </button>
        </div>
      </div>
      <label class="text-styling-panel__label">Out </label>
      <div class="text-styling-panel__time-row">
        <div class="text-styling-panel__time-input-wrap">
          <input
            type="text"
            class="text-styling-panel__time-input"
            [value]="outTimecode"
            (blur)="onOutTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="text-styling-panel__time-now-btn"
            title="Set to current playhead time"
            (click)="setOutToPlayhead()"
            aria-label="Set Out to playhead"
          >
            Now
          </button>
        </div>
      </div>
    </div>

    <!-- Colour palette -->
    <div class="text-styling-panel__section">
      <label class="text-styling-panel__label">Color</label>
      <evrideo-clipping-studio-color-swatch-picker
        [colors]="colors"
        [value]="activeColor"
        (valueChange)="setColor($event)"
      ></evrideo-clipping-studio-color-swatch-picker>
      <!-- Background color (with transparent) + padding -->
      <div class="text-styling-panel__section">
        <label class="text-styling-panel__label">Background</label>
        <evrideo-clipping-studio-color-swatch-picker
          [colors]="backgroundColors"
          [value]="isBackgroundTransparent ? 'transparent' : activeBackgroundColor"
          [allowTransparent]="true"
          (valueChange)="setBackgroundColor($event)"
        ></evrideo-clipping-studio-color-swatch-picker>
        <div
          class="text-styling-panel__padding-row"
          *ngIf="!isBackgroundTransparent"
        >
          <label class="text-styling-panel__padding-label">Padding</label>
          <input
            type="number"
            class="text-styling-panel__padding-input"
            [ngModel]="backgroundPadding"
            (ngModelChange)="setBackgroundPadding($event)"
            min="0"
            max="48"
            step="2"
          />
          <span class="text-styling-panel__padding-unit">px</span>
        </div>
        <div
          class="text-styling-panel__padding-row"
          *ngIf="!isBackgroundTransparent"
        >
          <label class="text-styling-panel__padding-label">Corner radius</label>
          <input
            type="number"
            class="text-styling-panel__padding-input"
            [ngModel]="backgroundBorderRadius"
            (ngModelChange)="setBackgroundBorderRadius($event)"
            min="0"
            max="48"
            step="2"
          />
          <span class="text-styling-panel__padding-unit">px</span>
        </div>
      </div>

      <!-- Drop shadow -->
      <div class="text-styling-panel__section">
        <label class="text-styling-panel__label">Drop shadow</label>
        <button
          type="button"
          class="text-styling-panel__align-btn text-styling-panel__align-btn--full"
          [class.text-styling-panel__align-btn--active]="dropShadow"
          (click)="toggleDropShadow()"
        >
          {{ dropShadow ? "On" : "Off" }}
        </button>
      </div>
    </div>

    <div class="text-styling-panel__footer">
      <button
        type="button"
        class="text-styling-panel__btn text-styling-panel__btn--primary"
        (click)="onSave()"
      >
        Save Changes
      </button>
      <button
        type="button"
        class="text-styling-panel__btn text-styling-panel__btn--secondary"
        [disabled]="templateActionBusy"
        (click)="onSaveAsTemplate()"
      >
        Save as template
      </button>
      <button
        *ngIf="showTemplateMutations"
        type="button"
        class="text-styling-panel__btn text-styling-panel__btn--secondary"
        [disabled]="templateActionBusy"
        (click)="onUpdateTemplate()"
      >
        Update template
      </button>
      <button
        *ngIf="showTemplateMutations"
        type="button"
        class="text-styling-panel__btn text-styling-panel__btn--danger"
        [disabled]="templateActionBusy"
        (click)="onDeleteTemplate()"
      >
        Delete template
      </button>
    </div>
  </div>
</div>
